module.exports = __webpack_public_path__ + "img/instrument_panel_tooling.7321e8fc.jpg";